import type { ReactNode } from 'react';
import { Spinner } from '@/components/common/Spinner';
import { ErrorState } from '@/components/common/ErrorState';

// Shared loading/error/content wrapper for an Edit tab, plus a top action bar
// mirroring the legacy "Cancel / Update Client" buttons (justify-content-end).
interface TabShellProps {
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  children: ReactNode;
}

export function TabShell({ isLoading, isError, onRetry, children }: TabShellProps) {
  if (isLoading) return <Spinner />;
  if (isError) return <ErrorState onRetry={onRetry} />;
  return <>{children}</>;
}

interface TabActionsProps {
  busy?: boolean;
  onCancel: () => void;
  submitLabel?: string;
  formId: string;
}

export function TabActions({ busy, onCancel, submitLabel = 'Update Client', formId }: TabActionsProps) {
  return (
    <div className="d-flex justify-content-end gap-2 mb-3">
      <button type="button" className="btn btn-dark" onClick={onCancel} disabled={busy}>
        Cancel
      </button>
      <button type="submit" form={formId} className="btn btn-primary" disabled={busy}>
        {busy ? 'Saving…' : submitLabel}
      </button>
    </div>
  );
}
